import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import WarningMessage from 'components/WarningMessage';
import { SprayEntityIds } from 'services/sprayEvents/types';
import { Entity } from 'services/entities/types';

import { Grid } from 'semantic-ui-react';
import { makeSelectEntitiesUnderMinTreeAge } from './selectors';

interface ConnectedProps {
    entitiesUnderMinTreeAge: Entity[];
}

export interface OwnProps {
    entityIds: SprayEntityIds;
    productId: number;
    date: string;
}

export type Props = OwnProps & ConnectedProps;

export class ProductMinimumTreeAgeMessageComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { entitiesUnderMinTreeAge } = this.props;

        if (entitiesUnderMinTreeAge.length > 0) {
            const entityNamesCSV = entitiesUnderMinTreeAge
                .map((entity) => entity.name)
                .join(', ');

            return (
                <Grid.Row>
                    <Grid.Column>
                        <div className="product-page-status-section">
                            <WarningMessage
                                title="Minimum tree age requirement not met for some areas"
                                content={entityNamesCSV}
                                visible
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>
            );
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entitiesUnderMinTreeAge: makeSelectEntitiesUnderMinTreeAge()
});

export default connect(mapStateToProps)(ProductMinimumTreeAgeMessageComponent);
